module.exports = __webpack_public_path__ + "img/tx.003a34c2.png";